import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { UserProfileService } from 'src/app/services/user-profile/user-profile.service';
import * as UserProfileActions from './user-profile.actions';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
@Injectable()
export class UserProfileEffects {
  constructor(
    private actions$: Actions,
    private userProfileService: UserProfileService
  ) {}

  loadUserProfile = createEffect(() =>
    this.actions$.pipe(
      ofType(UserProfileActions.loadUserProfile),
      switchMap(({ phoneNumber }) =>
        this.userProfileService.checkUserExists(phoneNumber).pipe(
          map((userProfile) =>
            UserProfileActions.loadUserProfileSuccess({ userProfile })
          ),
          catchError((error) =>
            of(
              UserProfileActions.loadUserProfileFailure({
                error: error.message || 'Failed to load user profile',
              })
            )
          )
        )
      )
    )
  );

  updateUserProfile = createEffect(() =>
    this.actions$.pipe(
      ofType(UserProfileActions.updateUserProfile),
      switchMap(({ updates }) => {
        const userId = updates.id;
        if (!userId) {
          return of(
            UserProfileActions.updateUserProfileFailure({
              error: 'User ID is required',
            })
          );
        }
        return this.userProfileService.updateUserProfile(userId, updates).pipe(
          map((userProfile) =>
            UserProfileActions.updateUserProfileSuccess({ userProfile })
          ),
          catchError((error) =>
            of(
              UserProfileActions.updateUserProfileFailure({
                error: error.message || 'Failed to update user profile',
              })
            )
          )
        );
      })
    )
  );
}
